// shared/services/firebase.ts
import { initializeApp } from "firebase/app";
import {
  getAuth,
  setPersistence,
  browserLocalPersistence,
  Auth,
} from "firebase/auth";
import { getConfig } from "./config";

const firebaseConfig = {
  staging: {
    apiKey: "AIzaSyBzrqohTHrCwbkzrla1jIH8QTiIIOK5qjs",
    authDomain: "auth-staging.pollinator.coop",
    projectId: "pollinator-staging",
    storageBucket: "pollinator-staging.firebasestorage.app",
    messagingSenderId: "145796146055",
    appId: "1:145796146055:web:93a72333c6f1b7ed45a922",
    measurementId: "G-99DYXWYRY4",
  },
  production: {
    apiKey: "AIzaSyD4JVf5PQmZxlNfWSWgVLaBeKrUAAyl3sA",
    authDomain: "auth.pollinator.coop",
    projectId: "pollinator-5e8ca",
    storageBucket: "pollinator-5e8ca.firebasestorage.app",
    messagingSenderId: "1046665486512",
    appId: "1:1046665486512:web:38d747353d9ce906d2db75",
    measurementId: "G-NY97TP2HYX",
  },
};

let authInstance: Auth | null = null;

export function clearFirebaseLocalStorage() {
  // Clear all keys used by Firebase Auth
  Object.keys(localStorage).forEach((key) => {
    if (
      key.startsWith("firebase:authUser:") ||
      key.startsWith("firebase:auth:")
    ) {
      localStorage.removeItem(key);
    }
  });
}

export async function initFirebase(): Promise<Auth> {
  if (authInstance) return authInstance;

  const { firebaseEnv } = getConfig();

  const f_config =
    firebaseConfig[firebaseEnv as keyof typeof firebaseConfig] ??
    firebaseConfig.staging;

  const app = initializeApp(f_config, "pollinator-app");

  authInstance = getAuth(app);

  await setPersistence(authInstance, browserLocalPersistence);

  return authInstance;
}
